export const CREATE_BUDGET = `
  mutation CreateBudget(
    $year: Int!
    $budgets: Budgets!
    $element1: String!
    $element2: String!
    $element3: String!
    $element4: String!
    $isReschedule: Boolean!
  ) {
    createBudget(
      createParams: {
        budgets: $budgets
        element1: $element1
        element2: $element2
        element3: $element3
        element4: $element4
        year: $year
        isReschedule: $isReschedule
      }
    ) {
      element1
      element2
      element3
      element4
      executionId
      requestedBy
      reviewedBy
      status
      year
      budgets {
        _0
        _1
        _2
        _3
        _4
        _5
        _6
        _7
        _8
        _9
        _10
        _11
      }
    }
  }
`
